import {useContext} from 'react';
import SymbolContextMobile from '../contextCreate/SymbolContextMobile'

const useSymbol = () => {
	return useContext(SymbolContextMobile);
};

export default useSymbol
